import React from 'react';

interface State { error: Error | null; info: string }

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  constructor(props: any) {
    super(props);
    this.state = { error: null, info: '' };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.setState({ info: info.componentStack || '' });
  }

  render() {
    if (this.state.error) {
      const { error, info } = this.state;
      return (
        <div style={{ padding: 32, fontFamily: 'monospace', background: '#FEF2F2', minHeight: '100vh' }}>
          <h1 style={{ color: '#DC2626', fontSize: 20, marginBottom: 16 }}>
            💥 React Render Error
          </h1>
          <div style={{ background: '#fff', border: '1px solid #FCA5A5', borderRadius: 8, padding: 20, marginBottom: 16 }}>
            <strong style={{ color: '#DC2626' }}>Error:</strong>
            <pre style={{ whiteSpace: 'pre-wrap', color: '#1A1814', marginTop: 8, fontSize: 13 }}>
              {error.message}
            </pre>
          </div>
          <div style={{ background: '#fff', border: '1px solid #FCA5A5', borderRadius: 8, padding: 20 }}>
            <strong style={{ color: '#DC2626' }}>Component Stack:</strong>
            <pre style={{ whiteSpace: 'pre-wrap', color: '#3D3A34', marginTop: 8, fontSize: 12, lineHeight: 1.6 }}>
              {info}
            </pre>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
